"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconOthersFilled = function IconOthersFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "4",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "38",
    cy: "25",
    r: "4",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "25",
    r: "4",
    fill: color
  }));
};

IconOthersFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconOthersFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconOthersFilled;
exports.default = _default;